import { SimpleClose } from 'src/components/svg/Closes';
import { useTranslation } from 'react-i18next';
import snowHead from 'src/assets/images/event/shop/snowHead.webp';
import { useModalContext } from 'src/hooks/useModalContext';
import { EventShopModalContainerProps } from '../types';

export const EventShopModalContainer = ({
  title,
  text,
  children
}: EventShopModalContainerProps) => {
  const { closeModal } = useModalContext();
  const { t } = useTranslation();

  return (
    <div className="rounded-[20px] max-w-[610px] relative w-full pt-10 ">
      <img src={snowHead} alt="alt" className="absolute top-9 768:top-5 max-w-[99%]" />
      <div className="flex rounded-[20px] gap-5 relative overflow-hidden flex-col px-5 bg-gc_border justify-center w-full items-center z-0">
        <SimpleClose onShow={closeModal} className="absolute 768:top-5 top-9 right-5" />
        <p className="text-center pt-10 text-sp_card_amount 768:text-[40px] text-2xl font-bold w-full">
          {t(title)}
        </p>
        <p className="text-sp_text font-bold 768:text-[25px] text-base text-center w-full">
          {t(text)}
        </p>
        {children}
      </div>
    </div>
  );
};
